const promoCodeData = {
    description: 'Save 25% Off Your First Order When You Subscribe!',
    code: '25off',
};

export default promoCodeData;
